import { useCallback, useEffect, useRef } from 'react';
import { identityExtractHTMLElement } from '@deephaven/utils';

/**
 * Return a ref that can be used to subscribe to scroll events.
 * @param onScroll Scroll event handler
 * @param extractHTMLElement Optional extraction handler to get the HTML element
 * to subscribe to scroll events. If no extraction handler is given, the argument
 * passed to the callback will be subscribed to if it is an HTML element.
 */
export function useOnScrollRef(onScroll) {
  var extractHTMLElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identityExtractHTMLElement;
  var cleanupRef = useRef();

  // Cleanup on unmount
  useEffect(() => () => {
    var _cleanupRef$current;
    return (_cleanupRef$current = cleanupRef.current) === null || _cleanupRef$current === void 0 ? void 0 : _cleanupRef$current.call(cleanupRef);
  }, []);
  return useCallback(ref => {
    var _cleanupRef$current2;
    (_cleanupRef$current2 = cleanupRef.current) === null || _cleanupRef$current2 === void 0 || _cleanupRef$current2.call(cleanupRef);
    var element = extractHTMLElement(ref);
    if (!element) {
      return;
    }
    element.addEventListener('scroll', onScroll);

    // Hold a reference to a function that can cleanup scroll event registration
    cleanupRef.current = () => {
      element.removeEventListener('scroll', onScroll);
      cleanupRef.current = undefined;
    };
  }, [extractHTMLElement, onScroll]);
}
export default useOnScrollRef;
//# sourceMappingURL=useOnScrollRef.js.map